import PaymentHistoryDetails from "../details/payment-details";

interface PaymentHistoryProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    paymentHistoryData: any | null;
}

export const PaymentHistory = ({ paymentHistoryData }: PaymentHistoryProps) => {
    return <PaymentHistoryDetails paymentHistoryData={paymentHistoryData} />;
}